import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Header from "@/components/Header";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function JoinInstitution() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const [joinCode, setJoinCode] = useState("");
  const [joining, setJoining] = useState(false);
  const [institution, setInstitution] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!joinCode.trim()) {
      toast.error("Enter a library or institution code.");
      return;
    }
    setJoining(true);
    try {
      const { data } = await api.post("/institutions/join", { join_code: joinCode });
      setInstitution(data.institution);
      if (data.user) setUser(data.user);
      toast.success("Institution access linked.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not join institution.");
    } finally {
      setJoining(false);
    }
  };

  return (
    <div className="min-h-screen bg-forge-900 text-forge-100">
      <Header />
      <main className="max-w-3xl mx-auto px-6 lg:px-10 py-12 sm:py-16">
        <div className="text-[10px] tracking-[0.4em] uppercase text-ember-500 mb-3">Join Institution</div>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight mb-3">Enter your library or institution code.</h1>
        <p className="text-sm text-forge-100/60 mb-10">
          Patron codes connect your account to a library, school, or public institution without requiring a class code.
        </p>

        {institution ? (
          <div className="border border-ember-500/25 bg-ember-500/8 p-8">
            <div className="text-[10px] uppercase tracking-[0.3em] text-ember-500 mb-3">Connected</div>
            <h2 className="font-serif text-3xl mb-2">{institution.name}</h2>
            <p className="text-sm text-forge-100/55 mb-8">Your patron access is active.</p>
            <button onClick={() => navigate("/dashboard")} className="px-5 py-2.5 bg-ember-500 hover:bg-ember-400 text-forge-900 font-semibold rounded-sm tracking-wide transition-all">
              Return to Dashboard
            </button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-8">
            <label className="block">
              <span className="block text-[10px] uppercase tracking-[0.3em] text-forge-100/50 mb-3">Library / Institution Code</span>
              <input
                value={joinCode}
                onChange={(e) => setJoinCode(e.target.value.toUpperCase())}
                className="w-full bg-transparent border-b border-white/15 focus:border-ember-500 outline-none py-3 text-forge-100 placeholder-forge-100/30 text-3xl font-mono tracking-[0.16em]"
                placeholder="FLINTLIBRARY"
                autoComplete="off"
              />
            </label>
            <div className="flex flex-wrap gap-4">
              <button disabled={joining} className="px-6 py-2.5 bg-ember-500 hover:bg-ember-400 disabled:opacity-60 text-forge-900 font-semibold rounded-sm tracking-wide transition-all">
                {joining ? "Joining..." : "Join Institution"}
              </button>
              <Link to="/dashboard" className="px-6 py-2.5 border border-white/15 hover:border-ember-500 hover:text-ember-400 text-sm tracking-wide rounded-sm transition-all">
                Cancel
              </Link>
            </div>
          </form>
        )}
      </main>
    </div>
  );
}
